import { render, staticRenderFns } from "./EditarAlerta.vue?vue&type=template&id=4b4a4a58&"
import script from "./EditarAlerta.vue?vue&type=script&lang=ts&"
export * from "./EditarAlerta.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports